import React from "react";
import ReactDOM from "react-dom/client";
import { store } from "store/store";
import App from "./App";
import "./index.css";
import { Provider } from "react-redux";

const initAmplitude = () => {
  import("utils/amplitude/amplitude").then(({ amplitude, trackEvents }) => {
    window.__trackEvents = trackEvents;
    
    const amplitudeApiKey = process.env.REACT_APP_AMPLITUDE_API_KEY;
    amplitude?.init(amplitudeApiKey, {
      serverZone: "EU",
      autocapture: {
        pageViews: { eventType: "page_viewed" },
      },
      defaultTracking: { sessions: true },
    });

    setTimeout(async () => {
      try {
        const { sessionReplayPlugin } = await import(
          "@amplitude/plugin-session-replay-browser"
        );
        amplitude.add(sessionReplayPlugin({ sampleRate: 0.1 }));
      } catch (e) {}
    }, 5000);
  });
};

if (typeof window !== "undefined") {
  if (document.readyState === "complete") {
    setTimeout(initAmplitude, 100);
  } else {
    window.addEventListener("load", () => setTimeout(initAmplitude, 100));
  }

  window.addEventListener("error", (e) => {
    const isChunkLoadError = e.message?.includes("Loading chunk");
    if (isChunkLoadError) {
      window.location.reload();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

import("utils/webVitals").then(({ reportWebVitals }) => reportWebVitals());
